module.exports = __webpack_public_path__ + "media/images/leaflet/marker-icon-black-1d6dc348b665fc577afdd874b348d153.png";